import React from 'react';
import './Timelapse.css';

const Timelapse = () => {
  // YouTube Video ID - Replace with your video ID when ready
  // You can paste either:
  // - Just the ID: "VIDEO_ID_HERE"
  // - Full URL: "https://www.youtube.com/watch?v=VIDEO_ID_HERE"
  // - Short URL: "https://youtu.be/VIDEO_ID_HERE"
  // - Shorts URL: "https://www.youtube.com/shorts/VIDEO_ID_HERE"
  const youtubeVideoId = "https://www.youtube.com/shorts/zPNkA1bj4ZE";
  
  // Helper function to extract video ID from various YouTube URL formats
  const getVideoId = (input) => {
    if (!input) return null;
    
    // If it's already just an ID (no special characters that would be in a URL)
    if (!input.includes('youtube.com') && !input.includes('youtu.be') && !input.includes('/')) {
      return input;
    }
    
    // Extract from various YouTube URL formats
    const patterns = [
      /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/shorts\/)([^&\n?#]+)/,
      /^([a-zA-Z0-9_-]{11})$/ // Direct video ID format
    ];
    
    for (const pattern of patterns) {
      const match = input.match(pattern);
      if (match && match[1]) {
        return match[1];
      }
    }
    
    return input; // Fallback to original input
  };
  
  const videoId = getVideoId(youtubeVideoId);
  
  // Build YouTube embed URL with autoplay and loop parameters
  // Note: For looping to work, we need to include the video ID in the playlist parameter
  const youtubeEmbedUrl = videoId 
    ? `https://www.youtube.com/embed/${videoId}?autoplay=1&loop=1&playlist=${videoId}&mute=1&controls=1&modestbranding=1&rel=0`
    : null;

  return (
    <section className="timelapse-section">
      <div className="timelapse-container">
        <div className="timelapse-header">
          <h2 className="timelapse-title">Growth in Motion</h2>
          <p className="timelapse-subtitle">
            Watch the incredible journey of plant growth captured through our timelapse collection
          </p>
        </div>
        
        <div className="timelapse-video-wrapper">
          {youtubeEmbedUrl ? (
            <iframe
              src={youtubeEmbedUrl}
              title="Plant Growth Timelapse Compilation"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              className="timelapse-youtube-iframe"
            ></iframe>
          ) : (
            <div className="timelapse-placeholder">
              <div className="timelapse-placeholder-icon">
                <i className="ri-time-line"></i>
              </div>
              <p className="timelapse-placeholder-text">
                Timelapse video coming soon
              </p>
              <p className="timelapse-placeholder-hint">
                Add your YouTube video ID to display the timelapse
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Timelapse;

